/* NSI swatch bridge (18 Oct 2026, kit bridge-fixes-2026-10-18/). Product pages only, while Swatch King is unavailable.

   1. Shade row (snippets/nsi-shade-row.liquid): fills each sister shade's photo, name and stock from
      /products/<handle>.js. Liquid can't do this on the server: all_products is capped at 20 handles a page and the
      cart drawer needs some of them. Fetched four at a time once the row is near the screen, and cached in
      sessionStorage for 10 minutes so moving between shades doesn't fetch again.
   2. Photo tiles on products with two options (e.g. Pink Powders, Size x Colour): after a change each tile shows the
      photo of the variant it would now pick. Missing and sold-out combinations come from the theme's own variant
      script (disabled / data-soldout) plus CSS in assets/nsi-site.css.
   3. Keeps every "Option: value" label in step; the theme only updates the first one.
   4. Enter on a photo tile picks that tile instead of submitting the form.
   5. Sold-out values stay tappable (soldout-sizes/, Andrew's D3, 20 Oct 2026): the theme's variant script disables
      them after every pick; we give them back at once, so a sold-out size, colour or type can be picked (its price
      and photos, Sold out on Add to cart, Notify me). Combinations that don't exist stay disabled.
   6. The 'In stock' / 'Out of stock' line under Add to cart follows the selected variant (soldout-sizes/, D6).
   7. Pre-order products (advent guard, 22 Oct 2026): with the BF chat's pre-order patch on the page, that line keeps the
      patch's own wording, classes and colours on every pick, and before the pre-sale opens Notify me says so.

   Steps aside when Swatch King's box or pre-hide style is on the page. */
(function () {
  'use strict';
  if (window.__nsiSwatchBridge) return;
  window.__nsiSwatchBridge = true;

  var TTL = 10 * 60 * 1000;
  var ROOT = '#shopify-section-static-product';

  function swatchKingHere() {
    return !!(document.querySelector('variant-swatch-king') || document.querySelector('style[data-vsk-hide]'));
  }
  /* the same photo can be written with its query in a different order; compare the file, not the string */
  function file(u) { return String(u || '').split('?')[0].replace(/^https?:/, ''); }
  function sized(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160&height=160&crop=top';
  }
  function cacheGet(handle) {
    try {
      var o = JSON.parse(sessionStorage.getItem('nsi-shade:' + handle));
      if (o && Date.now() - o.ts < TTL) return o;
    } catch (e) {}
    return null;
  }
  function cacheSet(handle, o) {
    try { o.ts = Date.now(); sessionStorage.setItem('nsi-shade:' + handle, JSON.stringify(o)); } catch (e) {}
  }
  function newImg(src, lazy) {
    var img = new Image();
    img.width = 70; img.height = 70; img.alt = ''; img.decoding = 'async';
    if (lazy) img.loading = 'lazy';
    img.src = src;
    return img;
  }

  /* 1. Shade row */
  function fillShade(a, d) {
    var label = a.getAttribute('data-nsi-shade-label') || d.t || a.title;
    var text = d.a ? label : label + ' (sold out)';
    a.title = text;
    var name = a.querySelector('[data-nsi-shade-name]');
    if (name) name.textContent = text;
    var ph = a.querySelector('.nsi-shade__ph');
    if (d.i && ph) ph.parentNode.replaceChild(newImg(sized(d.i), false), ph);
    if (!d.a) {
      a.classList.add('is-soldout');
      a.setAttribute('aria-disabled', 'true');
      a.tabIndex = -1;
    }
  }
  function shadeRows() {
    [].forEach.call(document.querySelectorAll(ROOT + ' [data-nsi-shades]'), function (row) {
      var queue = [];
      [].forEach.call(row.querySelectorAll('a[data-nsi-shade]:not(.is-current)'), function (a) {
        if (!a.querySelector('.nsi-shade__ph')) return;   /* launch 1: rendered on the server already, nothing to fetch */
        var cached = cacheGet(a.getAttribute('data-nsi-shade'));
        if (cached) fillShade(a, cached); else queue.push(a);
      });
      if (!queue.length) return;
      function next() {
        var a = queue.shift();
        if (!a) return;
        var handle = a.getAttribute('data-nsi-shade');
        fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
          .then(function (p) {
            var d = { t: p.title, i: p.featured_image, a: !!p.available };
            cacheSet(handle, d);
            fillShade(a, d);
          })
          .catch(function (status) {
            /* 404 = no longer on the online store: drop the tile, as Swatch King did for unpublished shades */
            if (status === 404) { var li = a.closest('li'); if (li) li.hidden = true; return; }
            /* a 429 or network blip: try once more after 2s, then leave the link (it still works) */
            if (!a.__nsiRetry) {
              a.__nsiRetry = 1;
              return new Promise(function (r) { setTimeout(r, 2000); }).then(function () { queue.push(a); });
            }
          })
          .then(next);
      }
      function start() {
        if (swatchKingHere()) return;
        for (var k = 0; k < 4; k++) next();
      }
      if ('IntersectionObserver' in window) {
        /* Keep watching while Swatch King is on the page: if its pre-hide lapses without the app mounting, the row
           comes back and still fills in. */
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting && !swatchKingHere()) { io.disconnect(); start(); return; }
          }
        }, { rootMargin: '600px 0px' });
        io.observe(row);
      } else {
        start();
      }
    });
  }

  /* 2 + 3. Photo tiles and labels */
  function tiles() {
    var dataEl = document.querySelector('script[data-section-type="static-product"][data-section-data]');
    var form = document.querySelector(ROOT + ' [data-product-form]');
    if (!dataEl || !form) return;
    var product;
    try { product = JSON.parse(dataEl.textContent).product; } catch (e) { return; }
    if (!product || !product.variants) return;
    var idSelect = form.querySelector('select[name="id"]');
    if (!idSelect) return;
    var sets = form.querySelectorAll('fieldset.nsi-tiles');
    var labels = form.querySelectorAll('[data-option-swatch-value]');

    function variantById(id) {
      for (var i = 0; i < product.variants.length; i++) if (product.variants[i].id === id) return product.variants[i];
      return null;
    }
    function variantByOptions(opts) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function refresh() {
      if (swatchKingHere()) return;
      var current = variantById(parseInt(idSelect.value, 10));
      if (!current) return;
      [].forEach.call(labels, function (label) {
        var value = current.options[parseInt(label.getAttribute('data-option-swatch-value'), 10)];
        if (value != null && label.textContent !== value) label.textContent = value;
      });
      /* screen readers: say "sold out", not just "dimmed" */
      [].forEach.call(form.querySelectorAll('fieldset.nsi-tiles .option-value-input, fieldset.nsi-buttons .option-value-input'), function (input) {
        var name = input.value + (input.getAttribute('data-soldout') === 'true' ? ' (sold out)' : '');
        if (input.getAttribute('aria-label') !== name) input.setAttribute('aria-label', name);
      });
      if (product.options.length < 2) return;
      [].forEach.call(sets, function (fieldset) {
        var index = parseInt(fieldset.getAttribute('data-nsi-position'), 10) - 1;
        [].forEach.call(fieldset.querySelectorAll('.option-value-input'), function (input) {
          var want = current.options.slice();
          want[index] = input.value;
          var match = variantByOptions(want);
          var tile = input.parentNode.querySelector('.nsi-tile');
          if (!tile || !match || !match.featured_image) return;
          var src = sized(match.featured_image.src || match.featured_image);
          var img = tile.querySelector('img');
          if (!img) {
            tile.textContent = '';
            tile.classList.remove('nsi-tile--text');
            img = newImg(src, true);
            tile.appendChild(img);
          } else if (file(img.getAttribute('src')) !== file(src)) {
            img.src = src;
          }
        });
      });
    }
    /* 5. Sold-out values stay tappable (Andrew's D3, 20 Oct 2026, kit inhouse-swatches-2026-10/soldout-sizes/).
       The theme's variant script (superstore.min.js, disableUnavailableVariants) disables every sold-out value on its
       first pass and again after each pick. Picking one is how a shopper reaches that option's price and photos, 'Sold
       out' on Add to cart and 'Notify me', so we give it back straight away: inside the theme's own change event on
       select[name=id] (fired right after it rates the values and before its refocus of the picked value), and again
       in update(). The value keeps data-soldout="true": faded, struck through or crossed out, '(sold out)' for screen
       readers. Only combinations that don't exist stay disabled, and assets/nsi-site.css keeps those hidden. */
    function openSoldOut() {
      if (swatchKingHere()) return;
      [].forEach.call(form.querySelectorAll('fieldset.nsi-tiles .option-value-input[data-soldout="true"], fieldset.nsi-buttons .option-value-input[data-soldout="true"]'), function (input) {
        if (input.disabled) input.disabled = false;
      });
    }
    /* 6. The stock line under Add to cart follows the selected variant (Andrew's D6, 20 Oct 2026, kit soldout-sizes/).
       snippets/product-form.liquid renders it once, on the server, for the variant the page opens on: a green dot and
       'In stock (dispatched within 1-2 business days)', or a red 'Out of stock' (.stock-status). Nothing refreshed it,
       so after a sold-out landing and an in-stock pick it still said 'Out of stock'. It now follows every change (the
       theme's change on select[name=id], its jQuery 'shopify-variants:switch-variant' and our 'nsi:variant-price'),
       from the same product data the theme's Add to cart button uses. The server's own nodes are kept and put back,
       so the opening state, and a gift card's own wording, never change. */
    var line = null;
    [].forEach.call(form.children, function (el) { if (!line && el.classList && el.classList.contains('stock-status')) line = el; });
    var lineNodes = {};
    /* 7. Pre-order products (advent guard, 22 Oct 2026, kit soldout-sizes/; Andrew "do this", decisions.md 22 Oct).
       The BF chat's pre-order patch in snippets/product-form.liquid (product tagged 'pre-order') prints its own line and
       a hidden properties[Pre-order] input; snippets/product-options.liquid prints the same label, note and opening
       text in [data-nsi-preorder], worked out the same way. With both on the page, a pick keeps the patch's own
       elements, classes, inline colours and wording, never text only:
         available                -> span.stock-dot (background:#b433c1) + span.stock-text (color:#b433c1) '<label>: <note>'
         sold out, before opening -> span.out-stock.nsi-preorder-soon (color:#b433c1) '<label> opens <date> (Qld time)'
         sold out, after opening  -> span.out-stock 'Out of stock', as on every product
       'Before opening' is the server's answer for this page view (the line it printed, else our data's flag), so a pick
       never disagrees with the line the page opened with. The hidden properties[Pre-order] input (the note on the cart,
       checkout and order lines) is only ever looked up, never changed. With the patch's input but none of our data (a
       half-done push or rollback) the line stays exactly as the server printed it; with our data but no patch on the
       page, the line works as on any other product. */
    var preData = form.querySelector('[data-nsi-preorder]');
    var preInput = form.querySelector('input[name="properties[Pre-order]"]');
    var pre = preData && preInput && preData.getAttribute('data-nsi-pre-in') ? preData : null;
    var preSoon = false;
    function lineState() {
      if (line.querySelector('.nsi-preorder-soon')) return 'soon';
      if (line.querySelector('.out-stock')) return 'out';
      return line.querySelector('.stock-text') ? 'in' : '';
    }
    if (pre && line) {
      var preOpened = lineState();
      preSoon = preOpened === 'soon' ||
        (preOpened !== 'out' && pre.getAttribute('data-nsi-pre-soon') === '1' && !!pre.getAttribute('data-nsi-pre-soon-text'));
    }
    function lineMake(state) {
      var a = document.createElement('span');
      if (state === 'soon') {
        a.className = 'out-stock nsi-preorder-soon';
        a.setAttribute('style', 'color:#b433c1');
        a.textContent = pre.getAttribute('data-nsi-pre-soon-text');
        return [a];
      }
      if (state === 'out') {
        a.className = 'out-stock';
        a.textContent = 'Out of stock';
        return [a];
      }
      var b = document.createElement('span');
      a.className = 'stock-dot';
      b.className = 'stock-text';
      if (pre) {
        a.setAttribute('style', 'background:#b433c1');
        b.setAttribute('style', 'color:#b433c1');
        b.textContent = pre.getAttribute('data-nsi-pre-in');
      } else {
        b.textContent = 'In stock (dispatched within 1-2 business days)';
      }
      return [a, b];
    }
    function stockLine() {
      if (!line) return;
      if (preInput && !pre) return;   /* the patch's line without our data: leave the server's line as it is */
      var v = variantById(parseInt(idSelect.value, 10));
      var shown = lineState();
      if (!v || !shown) return;
      var want = v.available ? 'in' : (preSoon ? 'soon' : 'out');
      if (want === shown) return;
      lineNodes[shown] = [].slice.call(line.childNodes);
      var next = lineNodes[want] || lineMake(want);
      while (line.firstChild) line.removeChild(line.firstChild);
      next.forEach(function (n) { line.appendChild(n); });
    }
    /* 8. Notify me before a pre-sale opens (advent guard, 22 Oct 2026). On such a page (item 7, before opening) the
       wishlist kit's Notify me (snippets/nsi-wishlist-pdp.liquid, assets/nsi-wishlist.js) would say 'Get an email if it
       comes back in stock' and, after a sign-up, 'Thanks, we'll email you if it comes back in stock.', for an edition
       that has never been on sale. Its title and its thanks line say 'when the pre-sale opens' instead. Text only:
       the block, its field, button, Klaviyo request and throttle stay the wishlist kit's, untouched, so a sign-up still
       gets Klaviyo's back-in-stock alert when the edition opens (with the pre-order wording). assets/nsi-site.css keeps
       the title invisible until this has run, so the old words never flash. After opening it all stays as it is. */
    var PRE_BIS_TITLE = 'Get an email when the pre-sale opens';
    var PRE_BIS_OK = "Thanks, we'll email you when the pre-sale opens.";
    function preBis() {
      if (!pre || !preSoon) return;
      [].forEach.call(form.querySelectorAll('[data-nsi-bis]'), function (blk) {
        var title = blk.querySelector('.nsi-bis__title'), msg = blk.querySelector('[data-nsi-bis-msg]');
        if (title) {
          if (title.textContent !== PRE_BIS_TITLE) title.textContent = PRE_BIS_TITLE;
          title.setAttribute('data-nsi-pre', '1');
        }
        if (!msg) return;
        /* the wishlist kit writes its thanks line as one text node in [data-nsi-bis-msg] with the class
           nsi-bis__msg--ok (after a sign-up, or when this option was already asked for today) */
        function okLine() {
          if (msg.classList.contains('nsi-bis__msg--ok') && msg.textContent !== PRE_BIS_OK) msg.textContent = PRE_BIS_OK;
        }
        okLine();
        if (window.MutationObserver) {
          new MutationObserver(okLine).observe(msg, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        }
      });
    }
    preBis();
    /* Launch 1 fix: the theme rates the picked value of each option from the picked variant alone. When it lands on a
       sold-out variant (e.g. Pink Powders 445g -> Coral Pink 2.0), the picked Size was crossed out, disabled and keyboard
       focus dropped to the page. The drop-down this replaced kept the picked value normal, so for every option but the
       last we keep it normal while an in-stock variant shares it (and the options before it). The last option still
       shows the exact combination as sold out, and Add to cart still says Sold out. */
    var refocus = null;
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('.option-value-input')) refocus = document.activeElement === t ? t : null;
    }, true);
    function keepPicked() {
      if (swatchKingHere()) return;
      var current = variantById(parseInt(idSelect.value, 10));
      var n = product.options.length;
      if (current && n > 1) {
        [].forEach.call(form.querySelectorAll('fieldset.nsi-buttons, fieldset.nsi-tiles'), function (fieldset) {
          var index = parseInt(fieldset.getAttribute('data-nsi-position'), 10) - 1;
          if (!(index >= 0 && index < n - 1)) return;
          var input = fieldset.querySelector('.option-value-input:checked');
          if (!input || input.getAttribute('data-soldout') !== 'true') return;
          var inStock = product.variants.some(function (v) {
            if (!v.available) return false;
            for (var j = 0; j <= index; j++) if (v.options[j] !== current.options[j]) return false;
            return true;
          });
          if (!inStock) return;
          input.disabled = false;
          input.setAttribute('data-soldout', 'false');
        });
      }
      if (refocus && refocus.checked && !refocus.disabled && document.activeElement !== refocus) {
        try { refocus.focus({ preventScroll: true }); } catch (e) { refocus.focus(); }
      }
      refocus = null;
    }
    function update() { openSoldOut(); keepPicked(); refresh(); stockLine(); }
    /* openSoldOut and stockLine also run synchronously inside the theme's own change event: it fires that event right
       after it rates (and disables) the values, and before it puts focus back on the picked value (soldout-sizes/) */
    idSelect.addEventListener('change', function () { openSoldOut(); stockLine(); setTimeout(update, 0); });
    /* also once after the theme's own first pass (a link to a sold-out variant) */
    setTimeout(update, 0);
    if (document.readyState !== 'complete') window.addEventListener('load', function () { setTimeout(update, 0); });
    /* the stock line also follows our price sync's event and the theme's jQuery event (soldout-sizes/, D6); jQuery
       comes with superstore.min.js, which runs after this script */
    document.addEventListener('nsi:variant-price', stockLine);
    var jqBound = false;
    function bindJq() {
      if (jqBound || !window.jQuery) return;
      jqBound = true;
      try { window.jQuery(window).on('shopify-variants:switch-variant.nsi-soldout', stockLine); } catch (e) {}
    }
    bindJq();
    if (!jqBound) {
      document.addEventListener('DOMContentLoaded', bindJq);
      window.addEventListener('load', bindJq);
    }
  }

  /* 4. Enter on a photo tile picks that tile. A radio inside the product form would otherwise submit the form and add
     the colour that was already selected. */
  function keys() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target || !e.target.matches) return;
      if (!e.target.matches(ROOT + ' .nsi-tiles .option-value-input, ' + ROOT + ' .nsi-buttons .option-value-input')) return;
      e.preventDefault();
      if (!e.target.checked && !e.target.disabled) e.target.click();
    }, true);
  }

  function init() {
    shadeRows();
    tiles();
    keys();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
